import React, { useEffect, useState } from "react";
import ContentSection from "../../../common/ContentSection";
import InvoiceForm from "../../../landingPage/pages/Plans/components/InvoiceForms/components/InvoiceForm";
import LandingTypography from "../../../landingPage/pages/Homepage/components/LandingTypography";
import { useRef } from "react";
import useInvoices from "../../../../../hooks/useInvoices";
import Loader from "../../../common/Loader";
import { compose } from "redux";
import withTranslations from "../../../../../hocs/withTranslations";
import Checkbox from "../../../../../lib/Checkbox/Checkbox";

const InvoiceDataBox = ({ translate, locale }) => {
  const invoiceFromRef = useRef(null);
  const {
    fetchSavedInvoiceData,
    loading,
    updateSavedInvoiceData,
    savedInvoicesEnabled
  } = useInvoices();
  const [showInvoiceForm, setShowInvoiceForm] = useState(false);

  useEffect(() => {
    fetchSavedInvoiceData();
  }, []);

  useEffect(() => {
    setShowInvoiceForm(savedInvoicesEnabled);
  }, [savedInvoicesEnabled]);

  return (
    <ContentSection>
      <h2 className="big-heading">{translate("invoice-data-box_title")}</h2>
      {loading ? (
        <Loader small />
      ) : (
        <LandingTypography>
          <form
            onSubmit={async e => {
              e.preventDefault();

              if (!showInvoiceForm) {
                updateSavedInvoiceData({
                  invoiceFormData: { invoicesEnabled: false }
                });
                return;
              }

              const invoiceFormData = await invoiceFromRef.current.submit();

              if (!invoiceFormData) {
                return;
              }

              updateSavedInvoiceData({
                invoiceFormData: { ...invoiceFormData, invoicesEnabled: true }
              });
            }}
          >
            <div className="mb-3">
              <Checkbox
                label={translate("plans_payment-bar_invoice")}
                className={"text-black-8"}
                checked={showInvoiceForm}
                onClick={() => {
                  setShowInvoiceForm(prevState => !prevState);
                }}
              />
            </div>
            {showInvoiceForm ? (
              <InvoiceForm
                translate={translate}
                locale={locale}
                ref={invoiceFromRef}
              />
            ) : null}
            <button className="button-1 mt-6" type="submit">
              {translate("invoice-data-box_save")}
            </button>
          </form>
        </LandingTypography>
      )}
    </ContentSection>
  );
};

export default compose(withTranslations)(InvoiceDataBox);
